import { Countries as CountryCode } from '../../../models/countries'

export const countryData = {
  [CountryCode.SE]: {
    widgetName: 'merchant-portal-se',
    contentLink: '//resurs-bank.humany.net/merchant-portal-se',
  },
  [CountryCode.DK]: {
    widgetName: 'merchant-portal-dk',
    contentLink: '//resurs-bank.humany.net/merchant-portal-dk',
  },
  [CountryCode.NO]: {
    widgetName: 'merchant-portal-no',
    contentLink: '//resurs-bank.humany.net/merchant-portal-no',
  },
  [CountryCode.FI]: {
    widgetName: 'merchant-portal-fi',
    contentLink: '//resurs-bank.humany.net/merchant-portal-fi',
  },
}

export const addHumanyScript = callback => {
  const scriptUrl = '//resurs-bank.humany.net/onewidgetimplementation/embed.js'

  const script = document.createElement('script')
  script.src = scriptUrl
  script.async = true
  script.onload = callback
  script.id = 'humany-script'

  document.body.appendChild(script)
}

export const removeHumanyScript = () => {
  const existingScript = document.getElementById('humany-script')
  if (existingScript) {
    existingScript.remove()
  }
}
